// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
// import Select from 'react-select';
import Markdown from 'react-markdown/with-html';

import Modal from '../Modal';
import SelectStack from '../../SelectStack';
import formatCurrency from '../../../utilities/formatCurrency';

export default class AttachFromMarketplace extends Modal {

    state = {
        stack: { _id: null, pipeline: [] }
    }

    getPipeline = () => {
        const stack = this.state.stack;
        if (!stack || !stack.pipeline)
            return [];
        return stack.pipeline;
    }

    getModule = (moduleId) => {
        const modules = this.props.data && this.props.data.modules ? this.props.data.modules : [];
        return modules.find(m => m._id === moduleId);
    }

    renderContent = () => {
        const m = this.props.data && this.props.data.module ? this.props.data.module : {};
        const s = this.props.data && this.props.data.stacks ? this.props.data.stacks : [];

        return (<div className="modal-content modal-center automate-attach">
            
            <img
                className="automate-attach-icon"
                src={m.icon}
                alt={m.name}
            />

            <h1>{m.name}</h1>
            <h3>Created by <strong>{m.creatorName}</strong></h3>

            <Markdown
                source={m.description}
                escapeHtml={false}
            />

            <p>
                Usage Pricing: <strong>{m.rate ? (m.rate >= 1 ? formatCurrency(m.rate) : (m.rate * 100).toString() + "¢") + " per document" : "FREE"}</strong>
                <br /><br />
            </p>

            <h2>Attach module to stack</h2>
            
            <div className="automate-pipeline">
                {/* <Select
                    className="select-container"
                    classNamePrefix="select"
                    value={this.state.stack}
                    options={s.map(s => ({
                        value: s._id,
                        label: s.path
                    }))}
                    isSearchable={true}
                    placeholder="Select stack..."
                    onChange={stack => this.setState({ stack })}
                /> */}

                <SelectStack
                    value={this.state.stack ? this.state.stack._id : ""}
                    onChange={stackId => {
                        const stack = s.find(stack => stack._id === stackId);
                        this.setState({ stack });
                    }}
                    stacks={s}
                />

                {this.state.stack._id && <>
                    <br />
                    {/* Stack */}
                    <div
                        className="automate-pipeline-step"
                        style={{ backgroundImage: "url('https://static.stax.ai/images/icons/" + (this.props.user && this.props.user.enableDarkMode ? "dark/" : "") + "folder.png')" }}
                    >Document received in stack</div>

                    {/* Intermediary steps */}
                    {this.getPipeline().map(step => {
                        const module = this.getModule(step.module);
                        if (!module)
                            return (<></>);

                        return (<>
                            <div className="automate-pipeline-pipe" />
                            <div
                                className="automate-pipeline-step"
                                style={{ backgroundImage: "url('" + module.icon + "')" }}
                            >{module.name}</div>
                        </>);
                    })}

                    {/* Add module */}
                    <div className="automate-pipeline-pipe" />
                    <div
                        className="automate-pipeline-step automate-pipeline-add"
                        style={{ backgroundImage: "var(--create-icon)" }}
                        title="Click to configure module for stack"
                        onClick={() => this.props.modal("automate-configure", {
                            module: m,
                            stack: this.state.stack,
                            reload: this.props.data.reload
                        })}
                    >Add module as next step</div>
                </>}

            </div>

        </div>);
    }

};